import { StyleProp, StyleSheet, ViewStyle } from 'react-native'

import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { colors, colors as zetColors } from '@zet/design-system'
import _ from 'lodash'

import TabLabel from './tabLabel'
import { TabsType } from './types'

const Tab = createMaterialTopTabNavigator()

type MyTabsProps = {
  tabs: Array<TabsType>
  isTransparent: boolean
  initalRouteName?: string
  activeTextColor?: string
  backgroundColor?: string
  tabBarIndicatorBGColor?: string
  tabBarScrollEnabled: boolean
  initialParams?: object
  tabBarItemStyle?: StyleProp<ViewStyle>
}

export default function TopBarTabs({
  tabs,
  isTransparent,
  initalRouteName,
  activeTextColor,
  backgroundColor,
  tabBarIndicatorBGColor,
  tabBarScrollEnabled = false,
  initialParams,
  tabBarItemStyle
}: MyTabsProps) {
  return (
    <Tab.Navigator
      initialRouteName={initalRouteName}
      sceneContainerStyle={{
        backgroundColor: isTransparent
          ? 'transparent'
          : colors.neutral.white100,
        flex: 1,
      }}
      screenOptions={{
        tabBarScrollEnabled: tabBarScrollEnabled,
        tabBarStyle: {
          backgroundColor: isTransparent
            ? 'transparent'
            : backgroundColor || colors.neutral.white100,
          elevation: 0,
          borderTopWidth: StyleSheet.hairlineWidth,
          borderBottomWidth: StyleSheet.hairlineWidth,
          borderTopColor: zetColors.grays[40],
          borderBottomColor: zetColors.grays[40],
        },
        tabBarItemStyle: tabBarItemStyle,
        tabBarIndicatorStyle: {
          backgroundColor: tabBarIndicatorBGColor || zetColors.primary[100],
          height: 3,
        },
        tabBarPressColor: colors.neutral.white100,
        lazy: true,
      }}
    >
      {_.map(tabs, (tab, index) => {
        return (
          <Tab.Screen
            initialParams={initialParams}
            key={'index' + index}
            name={tab.tabName}
            component={tab.TabComponent}
            // typo
            options={{
              tabBarLabel: ({ focused }) => (
                <TabLabel
                  isFocused={focused}
                  text={tab.tabTitle}
                  labelLeftComponent={tab.labelLeftComponent}
                  labelRightComponent={tab.labelRightComponent}
                  subText={tab.subTitle}
                  activeTextColor={activeTextColor}
                />
              ),
            }}
          />
        )
      })}
    </Tab.Navigator>
  )
}
